import React, { useEffect } from 'react';
import { useAwaitControl } from 'react-redux-await-control';

import { Files } from '~/screens/Contract/components/Tabs/Files/Files';
import { getDetails } from '~/store/contracts/actions';
import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type CardFilesViewProps = {
  contractId: string;
  backofficeContractId: number | string | null | undefined;
  onBack: () => void;
};

export function CardFilesView({ contractId, backofficeContractId, onBack }: CardFilesViewProps) {
  const detailsControl = useAwaitControl(getDetails);

  useEffect(() => {
    if (backofficeContractId) {
      detailsControl.start({ id: backofficeContractId });
    }
  }, [backofficeContractId]);

  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      {!!backofficeContractId && <Files />}
    </div>
  );
}
